import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-449db287"), n = n(), _popScopeId(), n);

const _hoisted_1 = /*#__PURE__*/_createTextVNode("北京华顺信安信息科技有限公司");

const _hoisted_2 = /*#__PURE__*/_createTextVNode("招商银行");

const _hoisted_3 = /*#__PURE__*/_createTextVNode("1109 3929 9192 939");

const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "warn"
}, " * 请在对公付款时务必备注订单号 ", -1));

const _hoisted_5 = {
  class: "copy"
};

const _hoisted_6 = /*#__PURE__*/_createTextVNode("一键复制");

const _hoisted_7 = {
  class: "info"
};

const _hoisted_8 = /*#__PURE__*/_createTextVNode(" 转账完成后, 我们确认收到汇款24小时内会为您发送一封电子邮件, 其中包含有关您订单的所有详情。(周末, 法定假日可能有延时)如有问题,请联系客服");

const _hoisted_9 = /*#__PURE__*/_createTextVNode("Gobyteam");

const _hoisted_10 = /*#__PURE__*/_createTextVNode("或发信息至邮箱");

const _hoisted_11 = /*#__PURE__*/_createTextVNode("gobysec@gmail.com");

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_descriptions_item = _resolveComponent("el-descriptions-item");

  const _component_el_descriptions = _resolveComponent("el-descriptions");

  const _component_el_button = _resolveComponent("el-button");

  const _component_el_link = _resolveComponent("el-link");

  return _openBlock(), _createElementBlock("div", null, [_createVNode(_component_el_descriptions, {
    title: "对公付款",
    column: "1"
  }, {
    default: _withCtx(() => [_createVNode(_component_el_descriptions_item, {
      label: "银行账户:"
    }, {
      default: _withCtx(() => [_hoisted_1]),
      _: 1
    }), _createVNode(_component_el_descriptions_item, {
      label: "银行名称:"
    }, {
      default: _withCtx(() => [_hoisted_2]),
      _: 1
    }), _createVNode(_component_el_descriptions_item, {
      label: "银行账户:"
    }, {
      default: _withCtx(() => [_hoisted_3]),
      _: 1
    }), _createVNode(_component_el_descriptions_item, {
      label: "汇款金额:"
    }, {
      default: _withCtx(() => [_createTextVNode("$ " + _toDisplayString(_ctx.total), 1)]),
      _: 1
    }), _createVNode(_component_el_descriptions_item, {
      label: "汇款备注:"
    }, {
      default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.orderNumber), 1)]),
      _: 1
    })]),
    _: 1
  }), _hoisted_4, _createElementVNode("div", _hoisted_5, [_createVNode(_component_el_button, {
    type: "primary"
  }, {
    default: _withCtx(() => [_hoisted_6]),
    _: 1
  })]), _createElementVNode("div", _hoisted_7, [_hoisted_8, _createVNode(_component_el_link, {
    type: "primary"
  }, {
    default: _withCtx(() => [_hoisted_9]),
    _: 1
  }), _hoisted_10, _createVNode(_component_el_link, {
    type: "primary"
  }, {
    default: _withCtx(() => [_hoisted_11]),
    _: 1
  })])]);
}